import Reveal from '../../../shared/Reveal/Reveal';
import { useHomeTtgContent } from '../../../../hooks/useHomeTtgContent';
import './TTG.css';

const TTG = () => {
  const { content, isLoading } = useHomeTtgContent();

  if (isLoading || !content) {
    return null;
  }

  const { quote, eagle, cards } = content;

  return (
    <section className="ttg">
      <div className="ttg__inner">
        <div className="ttg__intro">
          <Reveal as="blockquote" className="ttg__quote" delay={0}>
            “{quote}”
          </Reveal>

          <Reveal className="ttg__eagle-wrap" delay={120}>
            <img className="ttg__eagle" src={eagle} alt="" aria-hidden="true" />
          </Reveal>
        </div>

        <div className="ttg__cards">
          {cards.map(({ title, subtitle, icon }, index) => (
            <Reveal key={title} delay={index * 120}>
              <article className="ttg__card">
                <h3 className="ttg__card-title">{title}</h3>
                <p className="ttg__card-subtitle">{subtitle}</p>
                <img className="ttg__card-icon" src={icon} alt="" aria-hidden="true" />
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TTG;
